// import moment from 'moment';

// eslint-disable-next-line no-unused-vars
export const nominateYouthAgeVerify = (DOB) => {
  // const formattedDOB = moment(DOB, 'MMDDYYYY').format('YYYY-MM-DD');
  // const minAge = moment()
  //   .subtract(13, 'years')
  //   .format('YYYY-MM-DD');
  // return !moment(formattedDOB).isBefore(minAge);
  // For now we are removing completly the under age check;
  return false;
};
